import { Easing, useAnimatedStyle, useSharedValue, withTiming } from 'react-native-reanimated';

import { motion, shadows } from '../tokens';

/** The one curve: cubic-bezier(.22,1,.36,1). Durations: motion.fast 120 · motion.base 200 · motion.slow 320. */
export const EASE = Easing.bezier(0.22, 1, 0.36, 1);

/** Timing config on the one curve. Marked as a worklet so gesture handlers may call it on the UI runtime. */
export const timing = (duration: number) => {
  'worklet';
  return { duration, easing: EASE };
};

/**
 * Primary-CTA press: the face translates down `drop` px while the hard shadow plate collapses by the
 * same amount, in 120 ms on EASE. Consumers read `pressed` (0 → 1) for the shadow plate.
 */
export function usePressMotion(drop: number = shadows.pressDrop) {
  const pressed = useSharedValue(0);
  const onPressIn = () => {
    pressed.value = withTiming(1, timing(motion.fast));
  };
  const onPressOut = () => {
    pressed.value = withTiming(0, timing(motion.fast));
  };
  const faceStyle = useAnimatedStyle(() => ({ transform: [{ translateY: pressed.value * drop }] }));
  return { pressed, onPressIn, onPressOut, faceStyle };
}
